import { data as categoryData } from '../Categories/data'
import type { CategoryDataProps } from '../Categories/data'
const data = [
  {
    label: `Introduction`,
    id: `introduction`,
    href: `/customer-engagement-stack/introduction/`,
  },
  {
    label: `Categories`,
    items: categoryData.map((item: CategoryDataProps) => ({
      label: item.title,
      href: `/customer-engagement-stack/${item.slug}/`,
      id: item.slug,
    })),
  },
]

export default data
